import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { store } from "store";

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL + "graphql"
});

const authLink = setContext((_, { headers }) => {
  const token = store.getState().authState.userToken;

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ""
    }
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

export default client;
